// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu_button {\r\n\tdisplay: table-column;\r\n\tposition: fixed;\r\n\ttop: -35px;\r\n\tleft: -68px;\r\n}\r\n\r\n/* .history_button {\r\n\tposition: fixed;\r\n\ttop: 0px;\r\n\tleft: -334px;\r\n} */\r\n\r\n.history_button {\r\n    position: fixed;\r\n    top: 0px;\r\n    left: -225px;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
